<template>
  <div>
    <nav class="sidebar">
      <div class="sidebar-header">

        <a href="/dashboard" class="sidebar-brand">
          <img src="/assets/images/getsitelogo.png" width="40px" height="40px" /><span> Sales</span>
        </a>

        <div class="sidebar-toggler not-active">
          <span></span><span></span><span></span>
        </div>
      </div>

      <div class="sidebar-body">
        <ul class="nav">
          <!-- <li class="nav-item nav-category">{{ $t("MainTxt") }} </li> -->

          <!-- <li class="nav-item active">
            <a href="/mastersales" class="nav-link">
              <i class="link-icon" data-feather="box"></i>
              <span class="link-title">Sales</span>
            </a>
          </li> -->


          <!-- <li class="nav-item active" v-if="user_type=='CHAIN'">
            <a href="/dashboard" class="nav-link">
              <i class="link-icon" data-feather="box"></i>
              <span class="link-title">{{ $t("dashboardMenu") }}</span>
            </a>
          </li> -->


          <li class="nav-item nav-category">{{ $t("salesForecastData") }}</li>
          <span v-for="permision in permision_role" :key="permision.permission_role_id">
            <span v-if="permision.permission.controller == 'SalesForecastController' && permision.method_read == 1">
                <li class="nav-item">
                  <a href="/input-forecast" class="nav-link">
                    <i class="link-icon" data-feather="activity"></i>
                    <!-- <i class="mdi mdi-account-box-outline text-20" style ="font-size: 25;"></i> -->
                    <span class="link-title">{{ $t("inputForecastTxt") }}</span>
                  </a>
                </li>
              </span>
              <span v-if="permision.permission.controller == 'SalesForecastApprovalController' && permision.method_read == 1">
                <li class="nav-item">
                  <a href="/approval-forecast" class="nav-link">
                    <i class="link-icon" data-feather="bell"></i>
                    <!-- <i class="mdi mdi-account-box-outline text-20" style ="font-size: 25;"></i> -->
                    <span class="link-title">{{ $t("salesForecastApprovalTxt") }}</span>
                    <span class="badge rounded-pill bg-primary" style="margin-left: 20px">{{totalPendingApproval}}</span>
                  </a>
                </li>
              </span>
              
              <span v-if="permision.permission.controller == 'SalesForecastApprovalController' && permision.method_read == 1">
                <li class="nav-item">
                  <a href="/view-forecast" class="nav-link">
                    <i class="link-icon" data-feather="trello"></i>
                    <!-- <i class="mdi mdi-account-box-outline text-20" style ="font-size: 25;"></i> -->
                    <span class="link-title">{{ $t("viewForecastTxt") }}</span>
                  </a>
                </li>
              </span>
              <span v-if="permision.permission.controller == 'SalesForecastApprovalController' && permision.method_read == 1">
                <li class="nav-item">
                  <a href="/outstanding-member" class="nav-link">
                    <!-- <i class="mdi mdi-bike fa-2x" style="font-size:24px"></i> -->
                    <i class="link-icon" data-feather="list"></i>
                    <span class="link-title">{{ $t("outstandingMemberTxt") }}</span>
                  </a>
                </li>
              </span>
              <span v-if="permision.permission.controller == 'SalesForecastApprovalController' && permision.method_read == 1">
                
                <li class="nav-item">
                    <a class="nav-link" data-bs-toggle="collapse" href="#orders" role="button" aria-expanded="false"
                    aria-controls="emails">
                    <i class="link-icon" data-feather="shopping-bag"></i>
                    <span class="link-title">Forecast Report</span>
                    <i class="link-arrow mdi mdi-arrow-down-drop-circle"></i>
                  </a>
                    <div class="collapse" id="orders">
                      <ul class="nav sub-menu">
                    
                        <li class="nav-item">
                      <a href="/forecast-report-area" class="nav-link">{{$t("forecastReportMemberByAreaTxt")}}</a>
                    </li>
                    <li class="nav-item">
                        <a href="/forecast-report-customer" class="nav-link">{{$t("forecastReportMemberByCustomerTxt")}}</a>
                      </li>
                      <li class="nav-item">
                        <a href="/forecast-report-sales" class="nav-link">{{$t("forecastReportMemberBySalesTxt")}}</a>
                      </li>
                   
                 
                    
               
                 
                </ul>

                </div>
            </li>
              </span>
          </span>

          <!-- <li class="nav-item nav-category" v-if="user_type=='CHAIN'">{{ $t("transactionData") }}</li>


          <li class="nav-item" v-if="user_type=='CHAIN'">
            <a class="nav-link" data-bs-toggle="collapse" href="#orders" role="button" aria-expanded="false"
              aria-controls="emails">
              <i class="link-icon" data-feather="shopping-bag"></i>
              <span class="link-title">Order</span>
              <i class="link-arrow mdi mdi-arrow-down-drop-circle"></i>
            </a>
            <div class="collapse" id="orders">
              <ul class="nav sub-menu">
                <span v-for="permision in permision_role" :key="permision.permission_role_id">
                  <li class="nav-item"
                    v-if="permision.permission.controller == 'TransportOrderTemplateController' && permision.method_read == 1">
                    <a href="/order/transport-template" class="nav-link">Template Order</a>
                  </li>

                  <li class="nav-item"
                    v-if="permision.permission.controller == 'TransportOrderHeaderController' && permision.method_read == 1">
                    <a href="/order/transport-order" class="nav-link">Transport Order</a>
                  </li>
                </span>


              </ul>
            </div>
          </li> -->





          <br>
          <span>



            <li class="nav-item nav-category">{{ $t("masterData") }}</li>
            <span v-for="permision in permision_role" :key="permision.permission_role_id">


              <span v-if="permision.permission.controller == 'RegionController' && permision.method_read == 1">
                <li class="nav-item">
                  <a href="/region" class="nav-link">
                    <i class="link-icon" data-feather="bookmark"></i>
                    <span class="link-title">{{ $t("regionTxt") }}</span>
                  </a>
                </li>
              </span>

              <span v-if="permision.permission.controller == 'PackageController' && permision.method_read == 1">
                <li class="nav-item">
                  <a href="/package" class="nav-link">
                    <i class="link-icon" data-feather="package"></i>
                    <span class="link-title">{{ $t("packageTxt") }}</span>
                  </a>
                </li>
              </span>

              <span v-if="permision.permission.controller == 'PostalCodeController' && permision.method_read == 1">
                <li class="nav-item">
                  <a href="/postal-code" class="nav-link">
                    <i class="link-icon" data-feather="book"></i>
                    <span class="link-title">{{ $t("postalCodeTxt") }}</span>
                  </a>
                </li>
              </span>

              <span v-if="permision.permission.controller == 'CommodityController' && permision.method_read== 1">
                <li class="nav-item">
                  <a href="/commodity" class="nav-link">
                    <i class="link-icon" data-feather="aperture"></i>
                    <span class="link-title">{{ $t("commodityTxt") }}</span>
                  </a>
                </li>
              </span>

              <span v-if="permision.permission.controller == 'SystemCodeController' && permision.method_read == 1">
                <li class="nav-item">
                  <a href="/system-code" class="nav-link">
                    <i class="link-icon" data-feather="code"></i>
                    <span class="link-title">{{ $t("systemCodeTxt") }}</span>
                  </a>
                </li>
              </span>

              <span v-if="permision.permission.controller == 'SkuController' && permision.method_read == 1">
                <li class="nav-item">
                  <a href="/sku" class="nav-link">
                    <i class="link-icon" data-feather="archive"></i>
                    <span class="link-title">SKU</span>
                  </a>
                </li>
              </span>

              <span v-if="permision.permission.controller == 'LocationController' && permision.method_read == 1">
                <li class="nav-item">
                  <a href="/location" class="nav-link">
                    <i class="link-icon" data-feather="map"></i>
                    <span class="link-title">{{ $t("locationTxt") }}</span>
                  </a>
                </li>
              </span>
              <span v-if="permision.permission.controller == 'ForecastAvailableDateController' && permision.method_read == 1">
                <li class="nav-item">
                  <a href="/forecast_date" class="nav-link">
                    <i class="link-icon" data-feather="book"></i>
                    <span class="link-title">{{ $t("forecastdateTxt") }}</span>
                  </a>
                </li>
              </span>
              <!-- <span v-if="permision.permission.controller == 'BusinessUnitController' && permision.method_read == 1">
                <li class="nav-item">
                  <a href="/business_unit" class="nav-link">
                    <i class="link-icon" data-feather="book"></i>
                    <span class="link-title">{{ $t("businessunitTxt") }}</span>
                  </a>
                </li>
              </span>
              <span v-if="permision.permission.controller == 'AreaController' && permision.method_read == 1">
                <li class="nav-item">
                  <a href="/area" class="nav-link">
                    <i class="link-icon" data-feather="map"></i>
                    <span class="link-title">{{ $t("AreaTxt") }}</span>
                  </a>
                </li>
              </span> -->
              <span v-if="permision.permission.controller == 'SalesController' && permision.method_read == 1">
                <li class="nav-item">
                  <a href="/sales" class="nav-link">
                    <i class="link-icon" data-feather="user"></i>
                    <span class="link-title">{{ $t("salesTxt") }}</span>
                  </a>
                </li>
              </span>
              <!-- <span v-if="permision.permission.controller == 'CustomerController' && permision.method_read == 1">
                <li class="nav-item">
                  <a href="/customer" class="nav-link">
                    <i class="link-icon" data-feather="aperture"></i>
                    <span class="link-title">{{ $t("customerTxt") }}</span>
                  </a>
                </li>
              </span> -->
              <span v-if="permision.permission.controller == 'SalesApprovalController' && permision.method_read == 1">
                <li class="nav-item">
                  <a href="/sales_approval" class="nav-link">
                    <!-- <i class="mdi mdi-bike fa-2x" style="font-size:24px"></i> -->
                    <i class="link-icon" data-feather="users"></i>
                    <span class="link-title">{{ $t("salesApprovalTxt") }}</span>
                  </a>
                </li>
              </span>
             
            </span>
          </span>
          <br />
          <span >
           

            <span v-for="permision in permision_role" :key="permision.permission_role_id">
              <span v-if="permision.permission.controller == 'UserController'">
              <li class="nav-item nav-category">{{ $t("AdministrationTxt") }}</li>
            </span>

              <span v-if="permision.permission.controller == 'CompanyController'">
                <li class="nav-item">
                  <a href="/company" class="nav-link">
                    <i class="link-icon" data-feather="trello"></i>
                    <span class="link-title">{{ $t("companyTxt") }}</span>
                  </a>
                </li>
              </span>

              <span v-if="permision.permission.controller == 'UserController'">
                <li class="nav-item">
                  <a href="/users" class="nav-link">
                    <i class="link-icon" data-feather="user"></i>
                    <span class="link-title">{{ $t("txtUsers") }}</span>
                  </a>
                </li>
              </span>

              <span v-if="permision.permission.controller == 'RoleController'">
                <li class="nav-item">
                  <a href="/role" class="nav-link">
                    <i class="link-icon" data-feather="settings"></i>
                    <span class="link-title">{{ $t("txtRoles") }}</span>
                  </a>
                </li>
              </span>

              <span v-if="permision.permission.controller == 'PermissionController'">
                <li class="nav-item">
                  <a href="/permission" class="nav-link">
                    <i class="link-icon" data-feather="message-square"></i>
                    <span class="link-title">{{ $t("txtPermission") }}</span>
                  </a>
                </li>
              </span>

              <span v-if="
                permision.permission.controller == 'PermissionRoleController'
              ">
                <li class="nav-item">
                  <a href="/rolpermis" class="nav-link">
                    <i class="link-icon" data-feather="lock"></i>
                    <span class="link-title">{{
                    $t("txtPermissionRole")
                    }}</span>
                  </a>
                </li>
              </span>
            </span>
          </span>
        </ul>
      </div>
    </nav>
  </div>
</template>


<script>
export default {
  name: "sidebarMenu",
  props: {
    classMenu: {
      type: String,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      locale: "",
      name: "",
      email: "",
      role: "",
      permision_role: [],
      branchDatas: [],
      totalPendingApproval: 0,
      totalDoc: 0,
      totalSA: 0,
      user_type: '',
      companyFP: [],
    };
  },
  watch: {},
  methods: {
    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.name = userDatas.sub.name;
      this.email = userDatas.sub.email;
      this.role = userDatas.sub.role.name;
      this.user_type = userDatas.sub.user_type;
      this.permision_role = userDatas.sub.permision_role;

      if (this.role == "user_faktur_pajak") {
        this.loadCompanyFP();
      }

    },

    loadCompanyFP() {
      const baseURI = this.$settings.endPoint + `company/company-group-faktur-pajak`;
      return this.$http.get(baseURI).then((response) => {
        this.companyFP = response.data.datas;

      });
    },

    loadTotalAll() {
     
        const baseURI = this.$settings.endPoint + `forecast-approval/approval-notif`;
        return this.$http.get(baseURI).then((response) => {
          this.totalPendingApproval = response.data.datas;
       

        });
      
    },

    getBranch() {
      if (this.user_type == 'GT') {
        const baseURI = this.$settings.endPointCt + `branch/select-all-branch-with-pool`;
        return this.$http.get(baseURI).then((response) => {

          this.branchDatas = response.data.datas;

        });
      }
    },

    // loadTotalDoc(){
    //    if(this.user_type=='CT'){
    //     const baseURI = this.$settings.endPointCt + `real-monitoring/doc-alert`;
    //     return this.$http.get(baseURI).then((response) => {
    //       this.totalDoc = response.data.datas.total;
    //     });  
    //   }
    // },

    // loadTotalSA(){
    //   if(this.user_type=='CT'){
    //     const baseURI = this.$settings.endPointCt + `real-monitoring/service-alert`;
    //     return this.$http.get(baseURI).then((response) => {
    //       this.totalSA = response.data.datas.total;
    //     });  
    //   }
    // }
  },
  events: {},
  created: function () { },
  mounted() {
    this.fetchIt();
    this.loadTotalAll();
    this.getBranch();
    // this.loadTotalDoc();
    // this.loadTotalSA();
    // setInterval(() => {
    //    this.loadTotalTrip();
    // }, 500000);

  },
};
</script>
<style scoped>

</style>